import { render, staticRenderFns } from "./resto.vue?vue&type=template&id=2eecc33e"
import script from "./resto.vue?vue&type=script&lang=js"
export * from "./resto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports